import React from 'react'
import cx from 'classnames'
import { useDevice } from 'device'
import links from 'links'
import { track } from 'analytics'

import { HeroMediaBlock, Video, Text } from 'components/dataDisplay'
import { Button } from 'components/inputs'
import { WidthContainer } from 'components/layout'

import desktopPreview from './images/desktop-preview.jpg'
import mobilePreview from './images/mobile-preview.jpg'

import desktopVideo from './images/desktop.mp4'
import mobileVideo from './images/mobile.mp4'

import messages from './messages'


type QuizSectionProps = {
  className?: string
}

const QuizSectionAb: React.FC<QuizSectionProps> = ({ className }) => {
  const { isMobile } = useDevice()


  return (
    <HeroMediaBlock className={cx(className, 'relative', isMobile ? 'min-h-[588rem]' : 'min-h-[656rem]')} wideMT={false} wideMB={false}>
      <Video
        className="absolute left-0 top-0 w-full"
        videoClassName="bg-light-beige"
        url={isMobile ? mobileVideo : desktopVideo}
        preview={isMobile ? mobilePreview : desktopPreview}
        type="mp4"
        autoplay
        muted
        loop
        aspect={isMobile ? 416 / 588 : 1440 / 656}
        withBackground={false}
      />
      <WidthContainer className={cx('absolute inset-x-0', isMobile ? 'bottom-64 text-center' : 'top-1/2 -translate-y-1/2')}>
        <div className={cx('ml-auto', !isMobile && 'max-w-372')}>
          <Text
            style={isMobile ? 'h4' : 'h3'}
            color="gold-70"
            message={messages.title}
          />
          <Text
            className={isMobile ? 'mt-8' : 'mt-16'}
            style="p3"
            message={messages.text}
          />
          <Button
            className={isMobile ? 'mt-24' : 'mt-40'}
            title={messages.buttonTitle}
            to={links.smartRecommendations}
            size={56}
            width={320}
            fullWidthOnMobile
            inlineIcon={isMobile ? '32/arrow-right' : null}
            onClick={() => track('Banner click', {
              placement: 'Build your scent profile',
              content: 'Quiz',
              link: links.smartRecommendations,
              action: 'link',
            })}
            data-testid="takeQuiz"
          />
        </div>
      </WidthContainer>
    </HeroMediaBlock>
  )
}


export default QuizSectionAb
